//src/app/store.ts
import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../features/auth/authSlice';
import vacanciesReducer from '../features/vacancies/vacanciesSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    vacancies: vacanciesReducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
